import React, { useEffect, useState } from "react";
import { ResponsiveCalendar } from "@nivo/calendar";
import { Spin } from "antd";
import ApiService from "../../Components/apiService.js";
import { BASE_URL } from "../../Components/Constant";

const Heatmap = ({ reportId }) => {
    const [calendarData, setCalendarData] = useState([]);
    const [dateRange, setDateRange] = useState({ from: "", to: "" });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!reportId) return;

        const apiServiceForRecords = new ApiService(
            `${BASE_URL}/mt_reports/${reportId}`,
            { "Content-Type": "application/json" },
            "GET"
        );

        apiServiceForRecords
            .makeCall()
            .then((response) => {

                if (response.report && response.data.length > 0) {
                    const aggregationField = response.report.aggregation_fields?.[0] || "AnnualRevenue";
                    const dateField = "created_at";

                    const formattedData = response.data
                        .map(record => ({
                            day: new Date(record[dateField]).toISOString().split("T")[0],
                            value: record[aggregationField] ? parseFloat(record[aggregationField]) || 0 : 1
                        }))
                        .filter(record => record.day !== "Invalid Date");

                    if (formattedData.length > 0) {
                        const dates = formattedData.map(item => new Date(item.day));
                        const minDate = new Date(Math.min(...dates)).toISOString().split("T")[0];
                        const maxDate = new Date(Math.max(...dates)).toISOString().split("T")[0];

                        setDateRange({ from: minDate, to: maxDate });
                    } else {
                        setDateRange({ from: "2025-01-01", to: "2025-12-31" });
                    }

                    setCalendarData(formattedData);
                } else {
                    setCalendarData([]);
                }

                setLoading(false);
            })
            .catch((err) => {
                setError(err);
                setLoading(false);
            });
    }, [reportId]);

    if (!reportId) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'orange', fontStyle: 'bold' }}>
            Report not attached correctly.
        </div>
    );
    if (loading) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Spin size="large" />
        </div>
    );
    if (error) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'red', fontStyle: 'bold' }}>
            Error: {error.message || error.error}
        </div>
    );

    return (
        <ResponsiveCalendar
            data={calendarData}
            from={dateRange.from}
            to={dateRange.to}
            emptyColor="#eeeeee"
            colors={["#61cdbb", "#97e3d5", "#e8c1a0", "#f47560"]}
            margin={{ top: 10, right: 10, bottom: 50, left: 20 }}
            yearSpacing={40}
            monthBorderColor="#ffffff"
            monthLegendOffset={10}
            dayBorderWidth={2}
            dayBorderColor={"#ffffff"}
            legends={[
                {
                    anchor: "bottom-right",
                    direction: "row",
                    translateY: 36,
                    itemCount: 4,
                    itemWidth: 34,
                    itemHeight: 36,
                    itemDirection: "top-to-bottom"
                }
            ]}
        />
    );
};

export default Heatmap;
